import { authMachine } from "@/machines/auth-machine";

import type { ApplicationMosaic } from "@recordsure/unity-auth-machine";

const STORAGE_KEY = "unity_reload_diagnostics";
const MAX_ENTRIES = 20;

interface ReloadDetails {
  previousMosaics?: ApplicationMosaic[];
  nextMosaics?: ApplicationMosaic[];
  previouslyAuthenticated?: boolean;
  action?: "IN" | "OUT" | "CLEAR";
}

function summarizeMosaics(mosaics: ApplicationMosaic[]) {
  return mosaics.map(({ name, order, isLive }) => ({ name, order, isLive }));
}

export function recordReload(reason: string, details: ReloadDetails = {}) {
  const snapshot = authMachine?.getSnapshot();
  const entry = {
    timestamp: new Date().toISOString(),
    reason,
    authState: snapshot?.value,
    authenticated: snapshot?.matches("authenticated"),
    previouslyAuthenticated: details.previouslyAuthenticated,
    mosaics: summarizeMosaics(snapshot?.context.user?.mosaics ?? []),
    previousMosaics: details.previousMosaics == null ? undefined : summarizeMosaics(details.previousMosaics),
    nextMosaics: details.nextMosaics == null ? undefined : summarizeMosaics(details.nextMosaics),
    action: details.action,
  };

  console.info("[Unity reload diagnostics] Recording navigation", entry);
  try {
    const stored: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? "[]");
    if (!Array.isArray(stored)) throw new Error("Reload diagnostics must be an array.");
    const history: unknown[] = stored;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...history.slice(-(MAX_ENTRIES - 1)), entry]));
  } catch (error) {
    console.warn("[Unity reload diagnostics] Could not persist navigation reason", error);
  }
}

export function reportReloadDiagnostics() {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored != null) console.info("[Unity reload diagnostics] Previous navigation history", JSON.parse(stored));
  } catch (error) {
    console.warn("[Unity reload diagnostics] Could not read navigation history", error);
  }
}
